import type { ReactNode } from 'react';
import { cn } from '../utils/twUtils';

interface AuthFormProps {
  children: ReactNode;
  className?: string;
}

/**
 * Groups a screen's fields with the primary action that submits them.
 * Auth screens stack their sections at space-y-6 (24px); a field and its
 * button are one unit and sit closer, at space-y-4 (16px). This owns that
 * 16px so the gap can't drift per screen (it previously ranged 16-24px
 * via ad-hoc space-y-4 containers and !mt-4 overrides).
 */
const AuthForm = ({ children, className }: AuthFormProps) => (
  <div className={cn('space-y-4', className)}>{children}</div>
);

export default AuthForm;
